import yup from 'yup'

const passwordRex = new RegExp('^(?=.*\\d)(?=.*[!@#$%^&*\\.\\,\\:])(?=.*[a-z])(?=.*[A-Z]).{8,32}$');

const schema = yup
  .object()
  .shape({
    email: yup.string().email('Please enter a correct email').required('Email is required'),
    password: yup.string().matches(passwordRex, 'Invalid format').required('Password is required')
  })

export default schema



// WEBPACK FOOTER //
// ./src/forms/LoginForm/schema.js